module.exports = __webpack_public_path__ + "static/media/image-2.acec19ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/ConsumerBehaviour/image-2.jpg
// module id = 446
// module chunks = 0